import moment from "moment";

export const formatDate = (dateString, format = "DD/MM/YYYY") => moment(dateString).format(format);

export default function useDates() {
  const formattedDate = (dateString, format) => formatDate(dateString, format);

  const diffBetweenDates = (
    date1 = moment(),
    date2 = moment(),
    unitOfTime = 'days',
    precise = false
  ) => moment(date1).diff(moment(date2), unitOfTime, precise);

  const diffBetweenDatesHumanized = (date1, date2 = moment()) => moment(date1).from(date2);

  const diffInWeekdays = (startDate, endDate = moment()) => {
    let start = moment(startDate);
    let end = moment(endDate);
    let count = 0;

    while (start.isBefore(end, 'minute')) {
      const day = start.day();
      if (day !== 0 && day !== 6) { // Sunday = 0, Saturday = 6
        count++;
      }
      start.add(1, 'day');
    }

    return count;
  };


  return {
    formattedDate,
    diffBetweenDates,
    diffBetweenDatesHumanized,
    diffInWeekdays
  };
}
